/*
 * @Author: Json Chen
 * @Date: 2021-09-27 18:48:59
 * @LastEditTime: 2022-06-02 17:10:33
 * @LastEditors: Json Chen
 * @Description:
 * @FilePath: /unifyxp-v2-store-portal/src/components/Password/index.tsx
 */
import {
  CloseCircleFilled,
  EyeFilled,
  EyeInvisibleFilled,
} from '@ant-design/icons';
import React from 'react';
import Input from 'src/components/Antd/Input/Input';

const Password = Input.Password;

const CustomPassword = (props) => {
  const { editable, value, onChange, onEdit, size, passwordProps, disabled } =
    props;
  const handleOnChange = (value) => {
    if (onChange) {
      onChange(value);
    }
  };
  return editable ? (
    <Password
      size={size || 'large'}
      value={value}
      disabled={disabled}
      onChange={(e) => {
        handleOnChange(e.target.value.trim());
      }}
      allowClear
      iconRender={(visible) =>
        visible ? (
          <EyeFilled style={{ color: '#61d77c' }} />
        ) : (
          <EyeInvisibleFilled />
        )
      }
      {...(passwordProps || {})}
    />
  ) : (
    <Input
      value={value}
      size={size || 'large'}
      suffix={<CloseCircleFilled onClick={onEdit} />}
      disabled={disabled}
    />
  );
};
export default CustomPassword;
